import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface CurrentUserDetails {
  user: {
    employmentStatus?: 'Active' | 'Idle' | 'Terminated';
    role?: string;
    roles?: string[];
  };
}

@Injectable({ providedIn: 'root' })
export class CurrentUserDetailsService {
  constructor(private http: HttpClient) {}

  getAuthDetails$(): Observable<CurrentUserDetails> {
    return this.http.get<CurrentUserDetails>(`${environment.apiUrl}/users/me/auth-details`);
  }
}
